import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import GetIcon from "../../../../utils/Icon";
import { useGetAllAccountsQuery } from "../../../../store/api/itemtaxapi";
import { useGetItemTaxTemplatesQuery, useGetTaxcategoryQuery } from "../../../../store/api/gsthsn";

const Table = ({ selectedtaxes }) => {
    const [taxes, setTaxes] = useState([]);
    const [taxOptions, setTaxOptions] = useState([]);
    console.log(taxes,"taxes");
    
    const createNewRow = () => ({
        item_tax_template: "",
        tax_category: "",
        valid_from: "",
        min_net_rate: "",
        max_net_rate: ""
    });

    const [rows, setRows] = useState(
        selectedtaxes?.length > 0 
            ? selectedtaxes.map(tax => ({
                item_tax_template: tax.item_tax_template,
                tax_category: tax.tax_category,
                valid_from: tax.valid_from,
                min_net_rate: tax.minimum_net_rate.toString(),
                max_net_rate: tax.maximum_net_rate.toString()
            }))
            : [createNewRow()]
    );
   
    const tableRef = useRef();
    const dropdownRef = useRef();
    const [rowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRows, setSelectedRows] = useState([]);
    const [showDropdownIndex, setShowDropdownIndex] = useState(null);
    const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
    const [taxcat, setTaxcat] = useState([]);

    const { data: taxData } = useGetTaxcategoryQuery();
    const { data: templatedata } = useGetItemTaxTemplatesQuery();

    useEffect(() => {
        if (taxData?.data.length) {
            setTaxcat(taxData.data.map(item => ({ name: item.name })));
        }
    }, [taxData]);

    useEffect(() => {
        if (templatedata?.data?.length) {
            const newData = templatedata.data.map(item => ({ name: item.name }));
            setTaxOptions(newData);
        }
    }, [templatedata]);

    useEffect(() => {
        const formattedTaxes = rows
            .filter(row => 
                row.item_tax_template &&
                row.tax_category &&
                row.valid_from &&
                row.min_net_rate !== "" &&
                row.max_net_rate !== ""
            )
            .map(row => ({
                item_tax_template: row.item_tax_template,
                tax_category: row.tax_category,
                valid_from: row.valid_from,
                minimum_net_rate: parseFloat(row.min_net_rate) || 0,
                maximum_net_rate: parseFloat(row.max_net_rate) || 0
            }));
        
        setTaxes(formattedTaxes);
    }, [rows]);

    useEffect(() => {
        if (selectedtaxes?.length > 0) {
            setRows(selectedtaxes.map(tax => ({
                item_tax_template: tax.item_tax_template,
                tax_category: tax.tax_category,
                valid_from: tax.valid_from,
                min_net_rate: tax.minimum_net_rate.toString(),
                max_net_rate: tax.maximum_net_rate.toString()
            })));
        }
    }, [selectedtaxes]);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
    const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(rows.map((_, index) => index));
        } else {
            setSelectedRows([]);
        }
    };

    const toggleRowSelection = (index) => {
        setSelectedRows(prev =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        );
    };

    const updateRow = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const handleAddRow = () => {
        setRows([...rows, createNewRow()]);
        const lastPage = Math.ceil((rows.length + 1) / rowsPerPage);
        if (currentPage !== lastPage) setCurrentPage(lastPage);
    };

    const handleDeleteSelectedRows = () => {
        const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
        setRows(updatedRows);
        setSelectedRows([]);
        const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
        if (currentPage > lastPage) setCurrentPage(lastPage);
    };

    const handleSelectTax = (rowIndex, selectedItem, field) => {
        const updatedRows = [...rows];
        updatedRows[rowIndex][field] = selectedItem.name;
        setRows(updatedRows);
        setShowDropdownIndex(null);
    };

    return (
        <div className="table-container">
            <table className="table table-bordered mb-1" ref={tableRef}>
                <thead className="tableHead1">
                    <tr>
                        <th style={{ width: '4%', textAlign: 'center' }}>S.No</th>
                        <th style={{ width: '120px' }}>Item Tax Template</th>
                        <th style={{ width: '100px' }}>Tax Category</th>
                        <th style={{ width: '100px' }}>Valid From</th>
                        <th style={{ width: '100px' }}>Minimum Net Rate</th>
                        <th style={{ width: '100px' }}>Maximum Net Rate</th>
                        <th style={{ width: '80px', textAlign: 'center' }}>
                            <GetIcon iconName="PiSlidersHorizontalBold" size={12} />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {currentRows.map((row, index) => {
                        const globalIndex = indexOfFirstRow + index;
                        const showTaxDropdown = showDropdownIndex === globalIndex && 
                            (focusedCell.field === 'item_tax_template' || focusedCell.field === 'tax_category');

                        return (
                            <tr key={globalIndex} style={{ height: '30px' }}>                    
                                <td style={{ textAlign: "center" }}>
                                    <span style={{ fontSize: '0.8rem' }}>{globalIndex + 1}</span>
                                </td>
                                <td className="p-0 position-relative">
                                    <input
                                        type="text"
                                        className="form-control tableinput noborder"
                                        disabled
                                        value={row.item_tax_template}
                                        style={{ fontSize: '0.8rem', textAlign: 'center' }}
                                        onFocus={() => {
                                            setShowDropdownIndex(globalIndex);
                                            setFocusedCell({ rowIndex: globalIndex, field: 'item_tax_template' });
                                        }}
                                        onBlur={() => setTimeout(() => setShowDropdownIndex(null), 200)}
                                        onChange={(e) => updateRow(globalIndex, "item_tax_template", e.target.value)}
                                    />
                                    {showTaxDropdown && focusedCell.field === 'item_tax_template' && (
                                        <div
                                            ref={dropdownRef}
                                            className="dropdown-menu show"
                                            style={{
                                                width: '100%',
                                                maxHeight: '200px',
                                                overflowY: 'auto'
                                            }}
                                        >
                                            {taxOptions
                                                .filter(t => t.name.toLowerCase().includes(row.item_tax_template?.toLowerCase()))
                                                .map((tax, i) => (
                                                    <button
                                                        key={i}
                                                        className="dropdown-item"
                                                        type="button"
                                                        style={{ fontSize: '0.8rem' }}
                                                        onClick={() => handleSelectTax(globalIndex, tax, 'item_tax_template')}
                                                    >
                                                        {tax.name}
                                                    </button>
                                                ))}
                                        </div>
                                    )}
                                </td>
                                <td className="p-0 position-relative">
                                    <input
                                        type="text"
                                        className="form-control tableinput noborder"
                                        disabled
                                        value={row.tax_category}
                                        style={{ fontSize: '0.8rem', textAlign: 'center' }}
                                        onFocus={() => {
                                            setShowDropdownIndex(globalIndex);
                                            setFocusedCell({ rowIndex: globalIndex, field: 'tax_category' });
                                        }}
                                        onBlur={() => setTimeout(() => setShowDropdownIndex(null), 200)}
                                        onChange={(e) => updateRow(globalIndex, "tax_category", e.target.value)}
                                    />
                                    {showTaxDropdown && focusedCell.field === 'tax_category' && (
                                        <div
                                            ref={dropdownRef}
                                            className="dropdown-menu show"
                                            style={{
                                                width: '100%',
                                                maxHeight: '200px',
                                                overflowY: 'auto'
                                            }}
                                        >
                                            {taxcat
                                                .filter(t => t.name.toLowerCase().includes(row.tax_category?.toLowerCase()))
                                                .map((category, i) => (
                                                    <button
                                                        key={i}
                                                        className="dropdown-item"
                                                        type="button"
                                                        style={{ fontSize: '0.8rem' }}
                                                        onClick={() => handleSelectTax(globalIndex, category, 'tax_category')}
                                                    >
                                                        {category.name}
                                                    </button>
                                                ))}
                                        </div>
                                    )}
                                </td>
                                <td className="p-0">
                                    <input
                                        type="date"
                                        disabled
                                        className="form-control tableinput noborder"
                                        value={row.valid_from}
                                        style={{ fontSize: '0.8rem', textAlign: 'center' }}
                                        onChange={(e) => updateRow(globalIndex, "valid_from", e.target.value)}
                                    />
                                </td>
                                <td className="p-0">
                                    <input
                                        type="number"
                                        disabled
                                        className="form-control tableinput noborder"
                                        value={row.min_net_rate}
                                        placeholder="00.00"
                                        style={{ fontSize: '0.8rem', textAlign: 'center' }}
                                        onChange={(e) => updateRow(globalIndex, "min_net_rate", e.target.value)}
                                    />
                                </td>
                                <td className="p-0">
                                    <input
                                        type="number"
                                        className="form-control tableinput noborder"
                                        disabled
                                        value={row.max_net_rate}
                                        placeholder="00.00"
                                        style={{ fontSize: '0.8rem', textAlign: 'center' }}
                                        onChange={(e) => updateRow(globalIndex, "max_net_rate", e.target.value)}
                                    />
                                </td>
                                <td className="p-0">
                                    <GetIcon iconName="MdOutlineEdit" size={13} style={{ marginTop: '6px' }} />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className="d-flex pb-2 justify-content-between align-items-center">
                
                {rows.length > 10 && (
                    <>
                        <div className="d-flex align-items-center centerpagination">
                            <Pagination
                                setCurrentPage={setCurrentPage}
                                currentPage={currentPage}
                                pageSize={rowsPerPage}
                                totalrecords={rows.length}
                            />
                        </div>
                        <div className="d-flex">
                            <span className="px-2" style={{ color: '#270B79' }}>
                                Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
                            </span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Table;